<template>
  <div class="phone">
    <div class="head">
     <div class="camera"></div>
     <div class="Headset"></div>
    </div>
    <el-scrollbar class="phone-content" :class="{scroller: preview === 2}" :native="false">
      <div class="modules" :style="`padding:0 ${page.style.padding}px`">
        <template v-if="page.data.length>0">
          <draggable class="draggable" v-model="page.data" @end="dragEnd">
            <div
              class="item"
              v-for="(item,index) in page.data"
              :style="{marginTop:item.style.margin_top+'px',display:item.style.display}"
              :key="item.type+index">
              <component
                class="component-item"
                :class="{active:item===page.currentItem}"
                :is="item.type"
                :data="item"
                :style="`padding:0 ${item.style.padding}px;`"
                @click.capture.native="currentChange(item,$event)">
                <outline class="outline" @action="actionHandle"></outline>
              </component>
            </div>
          </draggable>
        </template>
        <template v-else>
          <el-button
            size="small"
            @click="modulesLayerShow=true"
            style="margin:0 auto;margin-top:100px;display:block;">
            添加组件
          </el-button>
        </template>
      </div>
    </el-scrollbar>
    <div class="bottom">
      <div class="touch"></div>
    </div>
    <el-dialog title="选择模块" :visible.sync="modulesLayerShow" :append-to-body="true" width="900px">
      <div class="modules-container">
        <div class="item" @click="addItem('swiper')" v-if="isShow('swiper')">
          <div class="icon"><img src="/static/images/icon/swiper.png"></div>
          <p>轮播图</p>
        </div>
        <div class="item" @click="addItem('images')" v-if="isShow('images')">
          <div class="icon"><img src="/static/images/icon/images.png"></div>
          <p>图片</p>
        </div>
        <div class="item" @click="addItem('collapse')" v-if="isShow('collapse')">
          <div class="icon"><img src="/static/images/icon/zdmb.png"></div>
          <p>折叠面板</p>
        </div>
        <div class="item" @click="addItem('richtext')" v-if="isShow('richtext')">
          <div class="icon"><img src="/static/images/icon/fwb.png"></div>
          <p>富文本</p>
        </div>
        <div class="item" @click="addItem('videoPlayer')" v-if="isShow('videoPlayer')">
          <div class="icon"><img src="/static/images/icon/sp.png"></div>
          <p>视频</p>
        </div>
        <div class="item" @click="addItem('wtitle')" v-if="isShow('wtitle')">
          <div class="icon"><img src="/static/images/icon/bt.png"></div>
          <p>标题</p>
        </div>
        <div class="item" @click="addItem('people')" v-if="isShow('people')">
          <div class="icon"><img src="/static/images/icon/people.png"></div>
          <p>人物|品牌</p>
        </div>
        <div class="item" @click="addItem('description')" v-if="isShow('description')">
          <div class="icon"><img src="/static/images/icon/people.png"></div>
          <p>文字描述</p>
        </div>
        <div class="item" @click="addItem('peopleDescribe')" v-if="isShow('peopleDescribe')">
          <div class="icon"><img src="/static/images/icon/article.png"></div>
          <p>专访</p>
        </div>
        <div class="item" @click="addItem('interview')" v-if="isShow('interview')">
          <div class="icon"><img src="/static/images/icon/article.png"></div>
          <p>对话</p>
        </div>
        <div class="item" @click="addItem('guest')" v-if="isShow('guest')">
          <div class="icon"><img src="/static/images/icon/people.png"></div>
          <p>嘉宾</p>
        </div>
        <div class="item" @click="addItem('interviewVideo')" v-if="isShow('interviewVideo')">
          <div class="icon"><img src="/static/images/icon/sp.png"></div>
          <p>访谈视频</p>
        </div>
      </div>
      <div class="modules-container" style="padding-top: 15px;border-top: 1px solid #eeeeee;">
        <div class="item" @click="addItem('movie')" v-if="isShow('movie')">
          <div class="icon"><img src="/static/images/icon/article.png"></div>
          <p>电影列表</p>
        </div>
        <div class="item" @click="addItem('talkList')" v-if="isShow('talkList')">
          <div class="icon"><img src="/static/images/icon/article.png"></div>
          <p>访谈列表</p>
        </div>
        <div class="item" @click="addItem('screeningList')" v-if="isShow('screeningList')">
          <div class="icon"><img src="/static/images/icon/article.png"></div>
          <p>放映项目</p>
        </div>
        <div class="item" @click="addItem('moviePanorama')" v-if="isShow('moviePanorama')">
          <div class="icon"><img src="/static/images/icon/article.png"></div>
          <p>展映列表</p>
        </div>
        <div class="item" @click="addItem('movieTrack')" v-if="isShow('movieTrack')">
          <div class="icon"><img src="/static/images/icon/article.png"></div>
          <p>动态列表</p>
        </div>
        <div class="item" @click="addItem('discussion')" v-if="isShow('discussion')">
          <div class="icon"><img src="/static/images/icon/article.png"></div>
          <p>讲座列表</p>
        </div>
        <div class="item" @click="addItem('topic')" v-if="isShow('topic')">
          <div class="icon"><img src="/static/images/icon/article.png"></div>
          <p>专题列表</p>
        </div>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import draggable from 'vuedraggable'
import outline from './outline'
import swiper from './modules/swiper'
import images from './modules/images'
import collapse from './modules/collapse'
import richtext from './modules/richtext'
import videoPlayer from './modules/videoPlayer'
import wtitle from './modules/wtitle'
import people from './modules/people'
import description from './modules/description'
import movie from './modules/movie'
import peopleDescribe from './modules/peopleDescribe'
import interview from './modules/interview'
import interviewVideo from './modules/interviewVideo'
import guest from './modules/guest'
import talkList from './modules/talkList'
import screeningList from './modules/screeningList'
import moviePanorama from './modules/moviePanorama'
import movieTrack from './modules/movieTrack'
import discussion from './modules/discussion'
import topic from './modules/topic'

export default {
  name: 'phone',
  components: {
    draggable,
    outline,
    swiper,
    images,
    collapse,
    richtext,
    videoPlayer,
    wtitle,
    people,
    description,
    movie,
    peopleDescribe,
    interview,
    interviewVideo,
    guest,
    talkList,
    screeningList,
    moviePanorama,
    movieTrack,
    discussion,
    topic
  },
  props: {
    preview: {
      type: Number
    },
    tool: {
      type: Array
    }
  },
  data () {
    return {
      modulesLayerShow: false,
      currentItem: '', // 当前激活模块
      location: ''
    }
  },
  computed: {
    page () {
      return this.$store.state.page
    }
  },
  methods: {
    isShow (name) {
      return this.tool.indexOf(name) > -1
    },
    currentChange (item, event) {
      console.log(123)
      this.currentItem = item
      this.$store.commit('SET_PAGE_CURRENTITEM', item)
      this.$emit('current-change', event)
    },
    actionHandle (type) {
      switch (type) {
        case 'top': // 上方添加
          this.location = type
          this.modulesLayerShow = true
          break
        case 'bottom': // 下方添加
          this.location = type
          this.modulesLayerShow = true
          break
        case 'delete': // 删除
          this.deleteItem()
          break
      }
    },
    deleteItem () {
      let data = this.page.data
      for (let i = 0; i < data.length; i++) {
        if (this.currentItem === data[i]) {
          data.splice(i, 1)
          this.$store.commit('SET_PAGE_CURRENTITEM', '')
          this.currentItem = ''
          return
        }
      }
    },
    addItem (type) {
      let data = this.page.data
      for (let i = 0; i < data.length; i++) {
        if (data[i] === this.page.currentItem) {
          if (this.location === 'top') {
            this.$store.commit('ADD_PAGE_ITEM', {
              index: i,
              type: type
            })
          }
          if (this.location === 'bottom') {
            this.$store.commit('ADD_PAGE_ITEM', {
              index: i + 1,
              type: type
            })
          }
          this.modulesLayerShow = false
          return
        }
      }
      this.$store.commit('ADD_PAGE_ITEM', {
        index: 0,
        type: type
      })
      this.modulesLayerShow = false
    },
    dragEnd (e) {
      console.log(e)
    }
  }
}
</script>
<style lang="less" scoped>
@height:60px;
@bg-color:#666666;
.display-flex {
  display: flex;
  align-items: center;
  justify-content: center;
}
.phone {
  width: 300px;
  border: 10px solid @bg-color;
  border-top: none;
  border-bottom: none;
  background-color: @bg-color;
  border-radius: 30px;
  overflow: hidden;
  .head {
    height: @height;
    .display-flex;
    .camera {
      padding: 3px;
      border-radius: 50%;
      background-color: #ffffff;
    }
    .Headset {
      height: 6px;
      width: 70px;
      background-color: #ffffff;
      border-radius: 3px;
      margin-left: 10px;
    }
  }
  .phone-content {
    min-height: 540px;
    background-color: #ffffff;
    box-sizing: border-box;
    overflow: hidden;
    /deep/ .el-scrollbar__wrap {
      overflow-x: hidden;
      font-weight: normal;
      padding-bottom: 12px;
    }
    &.scroller {
      height: 540px;
    }
    .component-item {
      position: relative;
      background-color: #ffffff;
      box-sizing: border-box;
      &:hover .outline {
        display: block;
      }
      &.active .outline {
        display: block;
      }
    }
  }
  .bottom {
    height: @height;
    .display-flex;
    .touch {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #ffffff;
    }
  }
}
.modules-container {
  display: flex;
  flex-wrap: wrap;
  .item {
    width: 110px;
    margin-bottom: 15px;
    text-align: center;
    cursor: pointer;
    border: 1px solid #dddddd;
    margin-right: 15px;
    &:hover {
      background-color: #F2F6FC;
    }
    .icon {
      width: 100px;
      height: 80px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      img {
        width: 60px;
        height: auto;
      }
    }
    p {
      margin-bottom: 10px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pages/components/phone.vue